import React, { useEffect, useState } from 'react';
import { UseFormMethods } from 'react-hook-form';
import Button from 'src/components/controls/forms/redesign/FormButton';
import RHFInputBox from 'src/components/controls/tempRHFControls/RHFInputBox';
import RHFSelect from 'src/components/controls/tempRHFControls/RHFSelect';
import InvoiceType from 'src/models/InvoiceType';

interface IInvoiceTypeListProps extends Partial<Pick<UseFormMethods, 'register' | 'errors' | 'control'>> {
    typeList?: Array<InvoiceType>;
    tsdiAccounts?: Array<{ code: number, description: string}>;
    selectedTypeList?: Array<InvoiceType>;
    getValues: () => { [x: string]: unknown; };
    resetValues: (i: number) => void;
}

const InvoiceTypeList = (props: IInvoiceTypeListProps) => {
    const addNewType = () => {
        let newType: InvoiceType = {
            id: 0,
            number: 0,
            code: 0,
            description: '',
            tsdiAccount: '',
        };

        let newList = [...invoiceTypes, newType];

        setInvoiceTypes(newList);
    };

    const [invoiceTypes, setInvoiceTypes] = useState<InvoiceType[]>([]);

    useEffect(() => {
        console.log('Form values', props.getValues());
        if (props.selectedTypeList?.length > 0) {
            setInvoiceTypes([...props.selectedTypeList]);
        } else {
            setInvoiceTypes([]);
        }
    }, [props.selectedTypeList]);

    useEffect(() => {
        if (!!invoiceTypes && invoiceTypes?.length > 0) {
            displayInvoiceTypes();
        }
    }, [invoiceTypes]);

    useEffect(() => {
        if (!!props?.typeList && props?.typeList?.length > 0) {
            setInvoiceTypes(props.typeList);
        }
    }, [props?.typeList]);

    const displayInvoiceTypes = () => {
        return (
            <div>
                {invoiceTypes && invoiceTypes?.map((it, index) => {
                    const selectedTsdiAccount = !!props?.tsdiAccounts && props?.tsdiAccounts?.length > 0 ?
                        props?.tsdiAccounts?.find((ta) => ta?.description === it?.tsdiAccount)?.code : 1;
                    return (
                        <div key={it.id} style={{ whiteSpace: 'nowrap', borderBottom: '1px solid darkgrey', marginBottom: '0.5rem', padding: '1rem' }}>
                            <div>
                                <RHFInputBox
                                    name={`invoiceTypes[${index}].number`}
                                    defaultVal={(!!it?.number ? it?.number : Math.max(...invoiceTypes?.map(ivt => ivt.number)) + 1).toString()}
                                    type={'number'}
                                    readOnly={true}
                                    register={props.register}
                                    style={{width: '100%' }}
                                    bodyStyle={{whiteSpace: 'nowrap', width: '15%' }}
                                />
                                <RHFInputBox
                                    label={'Description'}
                                    labelOnLeft={true}
                                    defaultVal={it?.description}
                                    name={`invoiceTypes[${index}].description`}
                                    style={{width: '100%' }}
                                    register={props.register}
                                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                                />
                                <RHFSelect
                                    label="Invoice Account"
                                    defaultVal={selectedTsdiAccount}
                                    name={`invoiceTypes[${index}].code`}
                                    register={props.register}
                                    errors={props.errors}
                                    options={!!props?.tsdiAccounts ? props?.tsdiAccounts?.map(ta => { return { value: ta.code, label: ta.description }; }) : [{ value: 1, label: 'no accounts'}]}
                                    style={{width: '100%' }}
                                    bodyStyle={{whiteSpace: 'nowrap', width: '100%' }}
                                />
                                <div style={{width: '50%', display: 'flex', justifyContent: 'flex-end' }}>
                                    <Button onClick={() => props.resetValues(index)} text="Delete" size="small" />
                                </div>
                            </div>
                        </div>
                    );
                })}
            </div>
        );
    };

    return (
        <>
            {displayInvoiceTypes()}

            <div>
                <Button onClick={addNewType} text="Add Invoice Type" />
            </div>
        </>
    );
};

export default InvoiceTypeList;


// WEBPACK FOOTER //
// ./src/components/project/sections/InvoiceTypeList.tsx